import React from 'react';
import { Smartphone, Download } from '@/components/DeskeyIcons';

// Android app download links, per login tab. Left empty until the apps are
// ready to hand out — a role with no link shows a disabled "Coming soon".
const DOWNLOAD_URLS = {
  teacher: null,
  student: null,
};

const APP_NAMES = {
  teacher: 'Deskey Teacher',
  student: 'Deskey Student',
};

/** "Get the app" card under the teacher / student login form. */
export default function MobileAppPromo({ role, accent }) {
  const appName = APP_NAMES[role];
  if (!appName) return null;
  const url = DOWNLOAD_URLS[role];

  return (
    <div className="mt-6 flex items-center gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3" data-testid={`mobile-app-promo-${role}`}>
      <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0" style={{ background: `${accent}1A`, color: accent }}>
        <Smartphone className="w-4 h-4" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold text-gray-900">Get the {appName} app</p>
        <p className="text-[11px] text-gray-500">Available for Android</p>
      </div>
      {url ? (
        <a href={url} className="shrink-0 inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold text-white" style={{ background: accent }} data-testid="mobile-app-download">
          <Download className="w-3.5 h-3.5" /> Download
        </a>
      ) : (
        <span className="shrink-0 rounded-lg px-3 py-1.5 text-xs font-semibold text-gray-400 bg-gray-100 cursor-not-allowed" aria-disabled="true" data-testid="mobile-app-coming-soon">
          Coming soon
        </span>
      )}
    </div>
  );
}
